exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uploader[data-v-3ea1660d] {\n  margin-bottom: 0.078125rem;\n}\n.wl-container[data-v-3ea1660d] {\n  background: #fff;\n  padding: 0.0625rem;\n}\n.wl-btn-container[data-v-3ea1660d] {\n  margin-top: 0.0625rem;\n  text-align: right;\n}\n.textarea[data-v-3ea1660d] {\n  border-color: #c0c4cc;\n  border-radius: 0.010417rem;\n}", ""]);

// exports
